<template>
	<drawer
			:title="titleDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		StatementNewItem

	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "StatementNewItem",
	mixins: [ validationMixin ],
	components: {
		Drawer
	},
	props: {
		activeItem: Object,
	},
	validations: {
		msg: { required },
		date: { required },
	},

	data() {
		return {
			titleDrawer: 'Request vacation',
			msg: '',
		};
	},
	methods: {
		onDate(value) {
			this.date = value;
		},
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { msg } = this.$data;
				this.$emit('updateSave', { msg }, this.activeItem);
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onAutocomplete({ value }, key) {
			this[key] = value.id;
		},
		onCheckbox({ value }, key) {
			this[key] = value;
		},
	},
	mounted() {
		if (this.activeItem) {
			const { msg } = this.activeItem;
			this.msg = msg;
		}
	}
};

</script>

<style scoped lang="scss">
.infoUserVacation {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 14px;
	.infoTitle {
		font-weight: bold;
		color: #a3a3a3;
	}
}

</style>
